/* eslint-disable import/no-cycle */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/alt-text */
import create from "zustand";
import React, { useState, useEffect } from "react";
// import useARStore from "../Store/arStore";
import { useResizeDetector } from "react-resize-detector";
import Frontend, { useButtonConfigStore } from "./Frontend";
import "./ARPage.css";
import ARControllerUI from "../components/ARControllerUI";
import ARPlatform from "../modules/ARPlatform";
import { AR_PLATFORM, AR_POSITION_SEEK } from "../constants";
import Event from "../modules/Event";
import ConfirmationPrompt from "../components/ConfirmationPrompt";
import LoadingBar from "./LoadingBar";

const store = (set) => ({
  showLoading: true,
  setShowLoading: (showLoading) => set({ showLoading }),
  showCalibration: true,
  setShowCalibration: (showCalibration) => set({ showCalibration }),
  showRecenter: false,
  setShowRecenter: (showRecenter) => set({ showRecenter }),
});

const useARPageStore = create(store);
export const ARPageState = useARPageStore.getState;

const ARPage = () => {
  const showLoading = useARPageStore((s) => s.showLoading);
  const showCalibration = useARPageStore((s) => s.showCalibration);
  const uiConfig = useButtonConfigStore((s) => s.uiConfig);
  const showRecenter = useARPageStore((s) => s.showRecenter);
  const platform = ARPlatform.getPlatform();
  const [GIFloaded, setGIFloaded] = useState(false);
  const [giferror, setGiferror] = useState(false);
  const { width, height, ref } = useResizeDetector();
  const [orientation, setOrientation] = useState("portrait");
  useEffect(() => {
    if (width > height) {
      setOrientation("landscape");
    } else {
      setOrientation("portrait");
    }
  }, [width, height]);
  return (
    <div ref={ref}>
      {showCalibration && platform === AR_PLATFORM.WEBXR && (
        <div id="calibrate" className="calibrate">
          <img src="./assets/calibrate.gif" id="calibrategif" />
          <h3>Calibrate your device</h3>
        </div>
      )}
      <div className={showLoading ? "XRPageInvisible" : "XRPageVisible"}>
        <ARControllerUI customStyleClass="xrPageAR" />
        {!GIFloaded && <LoadingBar />}
        {showRecenter && platform === AR_PLATFORM.EIGHTHWALL && (
          <div
            className={`recenter-prompt-${orientation}`}
            style={
              GIFloaded ? { visibility: "visible" } : { visibility: "hidden" }
            }
          >
            <div
              className={`hint-init-${orientation}`}
              style={giferror ? { height: "100px" } : { height: "380px" }}
            >
              {!giferror && (
                <>
                  <div className={`recentergif-${orientation}`}>
                    <img
                      src="./assets/r2.gif"
                      id={`recentergif-${orientation}`}
                      onLoad={() => {
                        setGIFloaded(true);
                      }}
                      onError={() => {
                        setGIFloaded(true);
                        setGiferror(true);
                      }}
                    />
                  </div>
                  <div className={`recenter-divider-${orientation}`} />
                </>
              )}
              <div className={`recenter-body-${orientation}`}>
                <div className={`recenter-text-${orientation}`}>
                  <p>Hold phone at chest level height.</p>
                </div>
                <div
                  className={`ok-btn-${orientation}`}
                  onClick={() => {
                    Event.sendSMEvent(AR_POSITION_SEEK.RECENTER);
                  }}
                >
                  OK
                </div>
              </div>
            </div>

            {/* {uiConfig &&
              uiConfig.submenu === true &&
              platform === AR_PLATFORM.EIGHTHWALL && (
                <>
                  <div className="hint-flash">
                    <p>Model does not look right? Tap on i.</p>
                  </div>
                </>
              )} */}
          </div>
        )}
        <Frontend />
        <ConfirmationPrompt />
      </div>
    </div>
  );
};

export default ARPage;
